/**
 * import and init third party
 * components/validators and other dependencies
 */

import Vue from 'vue'
import Default from '../layout/layout-default.vue'
import Installments from '../layout/layout-installments.vue'

Vue.component('layout-default', Default)
Vue.component('layout-login', Installments)
